import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PhysicianExperience, PhysicianExperienceData } from '../../../interfaces/masters/physician-experience';
import { PhysicianExperienceApi } from '../api/physician-experience.api';

@Injectable()
export class PhysicianExperienceService extends PhysicianExperienceData {

  constructor(private api: PhysicianExperienceApi) { 
    super(); 
  }

  list(url: string): Observable<PhysicianExperience[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PhysicianExperience>{
      return this.api.getById(url); 
  }

  create(url: string, data:PhysicianExperience[]): Observable<PhysicianExperience> {
    return this.api.add(url,data);
    
  }

  update(url: string, data:PhysicianExperience): Observable<PhysicianExperience> {
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 


}
